import { useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function HandleRedirect() {
  const { atHandle } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // The catch-all route only fires when nothing else matched. Only treat as a
    // handle shortlink when the segment begins with '@'.
    if (!atHandle || !atHandle.startsWith("@")) {
      navigate("/not-found", { replace: true });
      return;
    }
    const handle = atHandle.slice(1);
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/handle/${handle}`);
        if (cancelled) return;
        navigate(data.url_path, { replace: true });
      } catch {
        if (cancelled) return;
        navigate(`/handle-not-found/${handle}`, { replace: true });
      }
    })();
    return () => { cancelled = true; };
  }, [atHandle, navigate]);

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3">
      <Loader2 className="h-6 w-6 animate-spin text-[#FF3B30]" />
      <p className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">
        Finding {atHandle || ""}...
      </p>
    </div>
  );
}

export function HandleNotFound() {
  const { handle } = useParams();
  return (
    <div className="mx-auto max-w-[900px] px-6 py-24 md:px-10 text-center">
      <h1 className="font-display text-6xl uppercase text-white">@{handle}</h1>
      <p className="mt-3 text-neutral-400">
        Nothing to see here — this handle either doesn&apos;t exist or its owner hasn&apos;t shared a persona yet.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block border border-white/20 bg-[#FF3B30] px-4 py-2 font-mono text-[11px] uppercase tracking-widest text-white hover:bg-white hover:text-black"
      >
        Try Otaku//Index
      </Link>
    </div>
  );
}
